export interface ClassicImportOutcome {
  imported: string[];
  failed: string[];
  existing: string[];
  unset: string[];
}

export type ClassicImportPart =
  | 'imported'
  | 'nothing'
  | 'existing'
  | 'unset'
  | 'failed';

/** Translates one sentence; `names` already holds at most five, `more` counts the rest. */
export type ClassicImportText = (
  part: ClassicImportPart,
  values: { count: number; names: string; more: number }
) => string;

const SHOWN = 5;

/** One toast: what was copied, then why anything else was not. */
export function classicImportSummary(
  outcome: ClassicImportOutcome,
  text: ClassicImportText
): { level: 'success' | 'warning'; text: string } {
  const sentence = (part: ClassicImportPart, names: string[]) =>
    text(part, {
      count: names.length,
      names: names.slice(0, SHOWN).join(', '),
      more: Math.max(0, names.length - SHOWN),
    });
  const parts = [
    outcome.imported.length > 0
      ? sentence('imported', outcome.imported)
      : sentence('nothing', []),
    outcome.existing.length > 0 && sentence('existing', outcome.existing),
    outcome.unset.length > 0 && sentence('unset', outcome.unset),
    outcome.failed.length > 0 && sentence('failed', outcome.failed),
  ].filter(Boolean);
  return {
    level: outcome.failed.length > 0 ? 'warning' : 'success',
    text: parts.join(' '),
  };
}
